import { Box, Container, Divider, Flex, Grid, HStack, Image, Text, VStack } from "@chakra-ui/react";
import { WidgetTitle } from "@components/Texts/WidgetTitle/WidgetTitle";
import { Tile, TILE_MODES } from "@components/Tiles/Tile";
import { navigate } from 'gatsby';
import * as React from "react";
import Select from "react-select";
import { CarouselProvider } from "src/components/Carousel/Carousel";
import { CommonTags } from "src/containers/CommonTags/CommonTags";
import DynamicListBase from "../../components/DynamicListBase";
import { generateBlogCategoryUrl } from "../../core/paths";
import { PageCategory } from "../../core/types";
import AskQuestion from "../SensitiveQuestions/AskQuestion";
import { CATEGORY_MODES } from "./categoryModes.enum";
import { ChildrenChips } from "./components/ChildrenChips";
import { MainCategoryTile } from "./components/MainCategoryTile";
import { PrimaryPostTile } from "./components/PrimaryPostTile";
import { SecondaryPostTile } from "./components/SecondaryPostTile";
import "./scss/index.scss";


interface IProps {
  currentCategory: PageCategory;
  mainCategory: PageCategory;
  categories: PageCategory[];
  suggestedPosts: any[];
  tags: any[];
}

export class Page extends DynamicListBase<IProps> {
  public checkSelected = (currentCategory) => {
    return currentCategory.parent ? currentCategory.name : 'Wszystkie'
  }
  public goToLink = (link) => {
    return navigate(link)
  }

  render() {
    const { mainCategory, currentCategory, tags = [], pageTags = [], categories = [], suggestedPosts = [] } = this.props;
    const { hasNextPage, hasPrevPage } = this.state;
    const [firstPost, ...restPosts] = this.getPageData();

    if (mainCategory.name === 'TRUDNE PYTANIA') {
      return (
        <Container maxW="1130px" px="15px" mt="40px">
          <Flex alignItems="center" mb="2rem">
            <Image src="https://wp.mamaginekolog.pl/wp-content/uploads/2021/10/mgnews1.png" alt="" maxH="50px" mr="20px" />
            <Image src={mainCategory.categoryConfig?.logo?.sourceUrl} alt="" maxH="50px" mr="20px" />
            <Flex bg="rgba(255, 213, 79, 0.3)" w="100%" pl="41px" pr="21px" pt="21px" justifyContent="space-between" direction={{ base: 'column', sm: "row" }}>
              <Box pb="30px">
                <Text fontSize="20px" fontWeight="900" fontFamily="MuseoModerno">Męczy Cię trudny temat?</Text>
                <Text fontSize="13px" color="#817653">Napisz do nas anonimowo, postaramy się odpowiedzieć.</Text>
              </Box>
              <AskQuestion />
            </Flex>
          </Flex>

          {mainCategory.children?.nodes?.length > 0 && (
            <>
              <Box d={{ base: 'none', md: 'block' }}>
                <ChildrenChips mode={CATEGORY_MODES.ASK_QUESTIONS} mainCategory={mainCategory} currentCategory={currentCategory} childrenCategories={mainCategory.children?.nodes} />
              </Box>
              <Box d={{ base: 'block', md: 'none' }} mb="20px">
                <Select
                  defaultValue={{ value: 'all', label: 'Wszystkie' }}
                  onChange={(category: any) => category.slug ? this.goToLink(generateBlogCategoryUrl(category.slug, mainCategory.slug)) : this.goToLink(generateBlogCategoryUrl(mainCategory.slug))}
                  value={{ value: this.checkSelected(currentCategory), label: this.checkSelected(currentCategory) }}
                  maxMenuHeight={100}
                  options={[{
                    value: 'Wszystkie',
                    label: 'Wszystkie'
                  }, ...mainCategory.children?.nodes.map(category => ({ value: category.name, label: category.name, ...category }))]}
                />
              </Box>
            </>
          )}
          <PrimaryPostTile mode={CATEGORY_MODES.ASK_QUESTIONS} post={firstPost} mb="50px" tag="OSTATNI WPIS" />

          <HStack spacing="30px" mb="100px" alignItems="flex-start">
            <Box w="100%" maxW="830px" flexGrow={1 as any}>
              <VStack d={{ base: 'none', md: 'block' }} spacing="45px">
                {restPosts.map(post => (
                  <SecondaryPostTile key={post.id} post={post} />
                ))}
              </VStack>
              <VStack d={{ base: 'block', md: 'none' }} spacing="45px">
                {restPosts.map(post => (
                  <Tile key={post.id} d={{ base: 'block', sm: 'none' }} mode={TILE_MODES.SHORT_MOBILE_THUMBNAIL_RIGHT} article={post} />
                ))}
              </VStack>
            </Box>
          </HStack>
        </Container>
      )
    }

    const goTo = (link) => {
      return navigate(link)
    }

    const checkSelected = () => {
      return currentCategory.parent ? currentCategory.name : 'Wszystkie'
    }

    return (
      <Container maxW="1130px" px="15px" pt={{ base: '0', md: '2rem' }} pb={{ base: '0', md: "1rem" }}>
        <MainCategoryTile category={mainCategory} />
        <Box d={{ base: 'none', md: 'block' }}>
          {mainCategory.children?.nodes?.length > 0 && (
            <ChildrenChips mainCategory={mainCategory} currentCategory={currentCategory} childrenCategories={mainCategory.children?.nodes} />
          )}
        </Box>
        <Box d={{ base: 'block', md: 'none' }}>
          <Select
            defaultValue={{ value: 'all', label: 'Wszystkie' }}
            onChange={(category) => category.slug ? goTo(generateBlogCategoryUrl(category.slug, mainCategory.slug)) : goTo(generateBlogCategoryUrl(mainCategory.slug))}
            value={{ value: checkSelected(), label: checkSelected() }}
            maxMenuHeight={100}
            options={[{
              value: 'Wszystkie',
              label: 'Wszystkie'
            }, ...mainCategory.children?.nodes.map(category => ({ value: category.name, label: category.name, ...category }))]}
          />
        </Box>

        <PrimaryPostTile mt={{ base: '19px', md: 0 }} post={firstPost} mb={{ base: '20px', md: "50px" }} />

        <Divider bg="#DDECFB" h="2px" mb="35px" />

        <HStack spacing="30px" mb={{ base: "25px", md: '100px' }} flexWrap={{ base: 'wrap', md: "nowrap" }} alignItems="flex-start">
          <Box w="100%" maxW="830px" flexGrow={1 as any}>
            <VStack d={{ base: 'none', md: 'flex' }} spacing="45px">
              {restPosts.map(post => (
                <SecondaryPostTile key={post.id} post={post} />
              ))}
            </VStack>
            <VStack d={{ base: 'block', md: 'none' }} spacing="45px">
              {restPosts.map(post => (
                <Tile key={post.id} d={{ base: 'block', sm: 'none' }} mode={TILE_MODES.SHORT_MOBILE_THUMBNAIL_RIGHT} article={post} />
              ))}
            </VStack>
          </Box>
          <Box d={{ base: 'none', md: 'block' }} maxW="260px" w="100%">
            <CommonTags tags={pageTags} />
          </Box>
        </HStack>

        <Box d={{ base: 'block', md: 'none' }} mb="70px" maxW="260px" w="100%">
          <CommonTags tags={pageTags} />
        </Box>
        <VStack mx={{ base: "-15px", sm: "0" }} px={{ base: "15px", sm: "0" }} py="17px" d={{ base: 'block', md: 'none' }} background="#EAF4FF" alignItems="flex-start" >
          <WidgetTitle color="#222C63">ZOBACZ RÓWNIEŻ</WidgetTitle>
          <Box w="100%">
            <CarouselProvider>
              {suggestedPosts.map(post => (<Tile key={post.id} mode={TILE_MODES.SHORT_WITH_THUMBNAIL} article={post} />))}
            </CarouselProvider>
          </Box>
        </VStack>
        <VStack d={{ base: 'none', md: 'block' }} background="#EAF4FF" alignItems="flex-start" spacing="32px" px="77px" mx="-77px" py="49px">
          <WidgetTitle color="#222C63">ZOBACZ RÓWNIEŻ</WidgetTitle>
          <Grid templateColumns={{ base: "repeat(1, 1fr)", sm: "repeat(2, 1fr)", md: "repeat(4, 1fr)" }} gap="32px">
            {suggestedPosts.map(post => (<Tile key={post.id} mode={TILE_MODES.SHORT_WITH_THUMBNAIL} article={post} />))}
          </Grid>
        </VStack>
      </Container>
    );
  }
  //   return (
  //     <div className="container blog-category">
  //       <div className="blog-category__name">
  //         {currentCategory.name}
  //         {/* <ArticleNumber
  //           articleNumber={currentCategory.articleNumber}
  //           customClass="blog-category__article-number"
  //         /> */}

  //         <div className="hidden md:flex flex-wrap space-y-3 items-end mb-12">
  //           {categories.map(({ name, id, slug }) => (
  //             <Link
  //               to={generateBlogCategoryUrl(slug)}
  //               key={id}
  //               className={`${
  //                 currentCategory?.id === id
  //                   ? "bg-pink-1 text-white"
  //                   : "bg-grey-16"
  //               } transition-all duration-300 rounded-xl text-s font-semibold cursor-pointer h-10 mr-3 leading-10 px-10 cursor-pointer`}
  //             >
  //               {name}
  //             </Link>
  //           ))}
  //         </div>
  //       </div>
  //       <div className="dynamic-list">
  //         {hasPrevPage && (
  //           <button
  //             onClick={this.prevPage}
  //             className="blog-category__show-previous button"
  //           >
  //             Zobacz poprzednie
  //           </button>
  //         )}
  //         <CategoryArticleList posts={posts} />
  //         {hasNextPage && (
  //           <button onClick={this.nextPage} className="button">
  //             Zobacz następne
  //           </button>
  //         )}
  //       </div>
  //     </div>
  //   );
  // }
}

export default Page;
